export const ArchiveName = (name: string, isArchived: boolean) => {
  return isArchived ? `${name} [Archived]` : name;
};
